import React from 'react';

import { Helmet } from 'react-helmet';
import MUIProvider from '~/contexts/MUIProvider';
import { Link } from '~/lib/react-router-dom';

import { Button, Stack } from '@mui/material';

import PageHeader from '~/components/Common/Elements/PageHeader';

import DealCrawlerList from './components/DealCrawlerList';

export default function CrawlDealPage() {
  return (
    <MUIProvider>
      <Helmet>
        <title>Deal Crawlers</title>
      </Helmet>

      <PageHeader title="Deal Crawlers" />

      <Stack direction="row" justifyContent="flex-end">
        <Button variant="contained" color="primary" component={Link} to="/cruises/deal-crawler/create">
          Start crawler for a deal page
        </Button>
      </Stack>

      <DealCrawlerList />
    </MUIProvider>
  );
}
